import DealWatchHome from "../../../../content/projects/nepfin/dealwatch1.png";
import DealWatchDetail from "../../../../content/projects/nepfin/dealwatch2.png";
import React from 'react';
export default {
  DealWatchHome,
  DealWatchDetail,
  React
};